export type Category = {
  slug: string;
  name: string;
  icon: string;
  desc: string;
  count: number;
  tone: 'primary' | 'accent' | 'secondary';
};

export type Article = {
  id: string;
  title: string;
  excerpt: string;
  categorySlug: string;
  author: string;
  authorRole: string;
  date: string;
  readTime: string;
  views: number;
  comments: number;
  featured: boolean;
  image: string;
  tags: string[];
  content: string[];
};

export const site = {
  name: '瓜哥吃瓜',
  slogan: '今日份新鲜事，点开就到手',
  intro:
    '瓜哥吃瓜是一个把散落热点收拢到一处的中文资讯门户。我们不追猎奇，只把今天大家在聊什么、最新更新了什么，用最快的速度整理给你。',
  email: 'hello@guagechigua.example.com',
  tagline: '新瓜速递 · 最新更新 · 今日份新鲜事',
};

export const categories: Category[] = [
  {
    slug: 'yule',
    name: '娱乐圈',
    icon: 'ri-star-smile-line',
    desc: '台前幕后的大小动态，官宣、回应与作品进展',
    count: 168,
    tone: 'primary',
  },
  {
    slug: 'yingshi',
    name: '影视综艺',
    icon: 'ri-clapperboard-line',
    desc: '剧集、综艺、电影的开播定档与口碑讨论',
    count: 132,
    tone: 'accent',
  },
  {
    slug: 'redian',
    name: '网络热议',
    icon: 'ri-fire-line',
    desc: '正在被反复转发和争论的话题，看大家怎么说',
    count: 214,
    tone: 'primary',
  },
  {
    slug: 'shishang',
    name: '时尚生活',
    icon: 'ri-t-shirt-line',
    desc: '红毯造型、穿搭灵感与日常生活的松弛感',
    count: 96,
    tone: 'secondary',
  },
  {
    slug: 'shuma',
    name: '数码潮流',
    icon: 'ri-smartphone-line',
    desc: '新机、新装备与年轻人的第一波体验分享',
    count: 74,
    tone: 'accent',
  },
  {
    slug: 'qinggan',
    name: '情感星座',
    icon: 'ri-heart-3-line',
    desc: '关系里的观察笔记，以及一点轻松的心理话题',
    count: 88,
    tone: 'secondary',
  },
];

export const articles: Article[] = [
  {
    id: 'su-nianan-variety-ratings-top',
    title: '苏念安新综艺首播收视登顶 观众直呼"被治愈了"',
    excerpt:
      '苏念安常驻的慢综艺《周末慢半拍》首播即登顶同时段收视，节目里她徒手搭帐篷、烤糊玉米的片段被反复转发。',
    categorySlug: 'yingshi',
    author: '瓜妹',
    authorRole: '影视综艺观察',
    date: '2026-09-10',
    readTime: '4 分钟',
    views: 48210,
    comments: 326,
    featured: true,
    image:
      'https://readdy.ai/api/search-image?query=Warm%20editorial%20magazine%20illustration%20of%20a%20cozy%20weekend%20campsite%20with%20a%20small%20tent%2C%20soft%20peach%20and%20coral%20gradient%20background%2C%20stylized%20paper%20cut%20shapes%2C%20gentle%20afternoon%20light%2C%20minimal%20clean%20composition%2C%20no%20text&width=1200&height=800&seq=guagua-art-01&orientation=landscape',
    tags: ['综艺', '收视', '慢生活'],
    content: [
      '由苏念安常驻的慢节奏综艺《周末慢半拍》上周末正式开播，首期节目播出后迅速登上同时间段收视榜首。节目里，苏念安素颜出镜、徒手搭帐篷的画面被大量观众截图转发，相关话题在两小时内冲上热搜前列。',
      '相比以往精致的人设，这一季的她明显放松了许多。她会因为烤糊了玉米而懊恼，也会在溪边安静地发呆半小时。有观众评价说："看着她什么都不做地发呆，我居然也觉得被治愈了。"',
      '节目导演组在接受采访时透露，这一季刻意减少了任务和剧本，希望呈现更真实的相处状态。"我们没有安排任何冲突，嘉宾们自己就玩得很开心，这大概就是慢综艺最难得的地方。"',
      '从首期反馈来看，这档节目确实踩中了当下观众的情绪需求。在节奏越来越快的娱乐内容里，愿意慢下来的人反而成了稀缺品。后续能否稳住口碑，还要看节目组能不能守住这份松弛。',
    ],
  },
  {
    id: 'luyu-new-album-teaser',
    title: '陆屿官宣新专辑 先行曲上线三小时破百万',
    excerpt:
      '陆屿在个人账号发布了一张只有背影的预告图，配文两个字"回来了"，先行曲随即上线并迅速突破百万播放。',
    categorySlug: 'yule',
    author: '吃瓜观察员',
    authorRole: '娱乐圈追踪',
    date: '2026-09-10',
    readTime: '3 分钟',
    views: 39650,
    comments: 512,
    featured: true,
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20music%20themed%20editorial%20illustration%20with%20vinyl%20record%20and%20sound%20waves%2C%20warm%20amber%20and%20coral%20gradient%20background%2C%20stylized%20geometric%20shapes%2C%20soft%20studio%20lighting%2C%20minimal%20clean%20composition%2C%20no%20text&width=1200&height=800&seq=guagua-art-02&orientation=landscape',
    tags: ['新专辑', '音乐', '官宣'],
    content: [
      '沉寂了近两年的陆屿终于有了新动作。他在个人账号上发布了一张只有背影的预告图，配文只有两个字："回来了。"这条动态发布二十分钟后评论数就破了十万。',
      '随后先行曲正式上线，三小时内播放量突破百万，多个音乐平台的新歌榜都被这首歌占据。有乐评人评价，这次编曲明显比上一张专辑更克制，"少了很多炫技，反而更像在讲一件事"。',
      '据接近团队的人士透露，这张专辑陆屿参与了绝大部分词曲创作，其中三首歌是他在巡演间隙写下的。团队方面暂未公布完整发行时间，只表示"很快就会和大家见面"。',
    ],
  },
  {
    id: 'jiang-wanqing-red-carpet-look',
    title: '江晚晴红毯造型引热议 高定礼服背后的故事',
    excerpt:
      '一袭改良旗袍式礼服让江晚晴成为红毯焦点，设计师团队随后分享了这件礼服从画稿到成衣的三个月。',
    categorySlug: 'shishang',
    author: '瓜妹',
    authorRole: '时尚生活观察',
    date: '2026-09-09',
    readTime: '5 分钟',
    views: 27340,
    comments: 198,
    featured: false,
    image:
      'https://readdy.ai/api/search-image?query=Elegant%20fashion%20editorial%20illustration%20of%20a%20flowing%20dress%20silhouette%20on%20a%20mannequin%2C%20warm%20blush%20and%20gold%20gradient%20background%2C%20stylized%20fabric%20drapes%2C%20soft%20studio%20lighting%2C%20minimal%20clean%20composition%2C%20no%20text&width=1200&height=800&seq=guagua-art-03&orientation=landscape',
    tags: ['红毯', '高定', '造型'],
    content: [
      '前晚的年度盛典红毯上，江晚晴以一袭改良旗袍式礼服出场，瞬间成为全场镜头焦点。与常见的蓬裙不同，这件礼服走的是收腰长摆的路线，领口保留了立领的设计。',
      '设计师团队随后在社交平台分享了这件礼服的制作过程：从最初的手绘稿到最终成衣，前后花了三个月。"最难的是面料的垂坠感，我们试了七种不同材质才定下来。"',
      '有意思的是，礼服上并未出现任何显眼的品牌标识。团队解释，这是江晚晴本人的坚持："她希望衣服是为主角服务的，而不是反过来。"',
      '截至发稿，相关话题的讨论仍在继续，不少网友已经开始二次创作同款搭配。比起"好不好看"，更多人讨论的其实是这件礼服透露出的审美取向。',
    ],
  },
  {
    id: 'gu-nanchuan-replies-rumors',
    title: '顾南川回应"耍大牌"传闻：希望大家看完节目再评价',
    excerpt:
      '面对一段被剪成三十秒的流传片段，顾南川在直播中正面回应，表示"断章取义的东西，解释一百次也没用"。',
    categorySlug: 'redian',
    author: '吃瓜观察员',
    authorRole: '网络热议追踪',
    date: '2026-09-09',
    readTime: '4 分钟',
    views: 52180,
    comments: 731,
    featured: true,
    image:
      'https://readdy.ai/api/search-image?query=Conceptual%20editorial%20illustration%20about%20online%20discussion%20and%20speech%20bubbles%2C%20warm%20terracotta%20and%20cream%20gradient%20background%2C%20stylized%20rounded%20shapes%2C%20soft%20diffused%20lighting%2C%20minimal%20clean%20composition%2C%20no%20text&width=1200&height=800&seq=guagua-art-04&orientation=landscape',
    tags: ['回应', '热搜', '分寸'],
    content: [
      '一段时长三十秒的现场片段在社交平台流传开来，画面里顾南川似乎对工作人员态度冷淡，很快"耍大牌"的说法被推上热搜。',
      '当晚的直播中，顾南川主动回应了这件事。他表示那段画面来自一次连续拍摄十四个小时后的休息间隙，"当时确实很累，但我没有对任何人不礼貌，完整节目播出来大家就明白了"。',
      '他还提到，自己并不介意被讨论，"被讨论是工作的一部分"。真正让他介意的是，"断章取义的东西，解释一百次也没用，只能把作品做好"。',
      '这个回应并没有让所有争议消失，但评论区里支持与质疑的声音开始变得均衡。有网友留言："等正片吧，先别急着定性。"',
    ],
  },
  {
    id: 'lin-xiaoman-new-drama-leak',
    title: '林小满新剧路透曝光 与程星野对手戏引发期待',
    excerpt:
      '一组片场路透照流出，林小满与程星野在雨中对戏的画面被网友称为"年度最好磕的一幕"。',
    categorySlug: 'yingshi',
    author: '瓜妹',
    authorRole: '影视综艺观察',
    date: '2026-09-08',
    readTime: '3 分钟',
    views: 31470,
    comments: 245,
    featured: false,
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20illustration%20of%20a%20rainy%20street%20scene%20with%20warm%20street%20lamp%20glow%2C%20muted%20blue%20grey%20and%20coral%20accents%2C%20stylized%20silhouettes%2C%20soft%20bokeh%20light%20dots%2C%20minimal%20clean%20composition%2C%20no%20text&width=1200&height=800&seq=guagua-art-05&orientation=landscape',
    tags: ['新剧', '路透', '对手戏'],
    content: [
      '一组片场路透照在网上流传开来，画面中林小满与程星野站在雨中，两人隔着几步距离对望。照片画质不算清晰，但氛围感拉满。',
      '据现场工作人员描述，这场戏从傍晚拍到深夜，为了等一场自然的雨，剧组前后调整了三次拍摄计划。"两位演员全程没有用替身，衣服湿透了还在调整走位。"',
      '该剧目前仍在拍摄阶段，尚未公布定档时间。不过仅凭这组路透，相关话题的预约人数已经涨了一波。',
    ],
  },
  {
    id: 'shen-zhibai-concert-extra-show',
    title: '沈知白演唱会加场 门票开售十分钟售罄',
    excerpt:
      '原定两场的巡演因预约人数远超预期而临时加场，加场门票同样在十分钟内被抢空。',
    categorySlug: 'yule',
    author: '吃瓜观察员',
    authorRole: '娱乐圈追踪',
    date: '2026-09-08',
    readTime: '3 分钟',
    views: 28960,
    comments: 402,
    featured: false,
    image:
      'https://readdy.ai/api/search-image?query=Concert%20stage%20editorial%20illustration%20with%20warm%20spotlights%20and%20crowd%20silhouettes%2C%20amber%20gold%20and%20deep%20coral%20gradient%20background%2C%20stylized%20light%20beams%2C%20soft%20glow%2C%20minimal%20clean%20composition%2C%20no%20text&width=1200&height=800&seq=guagua-art-06&orientation=landscape',
    tags: ['演唱会', '巡演', '加场'],
    content: [
      '沈知白的巡演原本只安排了两场，开放预约后人数远超预期，主办方随后宣布加开一场。让人没想到的是，加场门票同样在开售十分钟内售罄。',
      '主办方在公告中表示，舞台设计已按三场规模重新调整，"希望到场的每一位都能看到完整的舞台效果"。同时提醒观众通过官方渠道购票，谨防加价转售。',
      '一位抢到票的观众在评论区写道："抢票比考试还紧张，但抢到的那一刻是真的开心。"',
    ],
  },
  {
    id: 'wenyan-first-design-collab',
    title: '温言跨界做设计 首个联名系列上线',
    excerpt:
      '从演员到设计师，温言花了两年时间学习打版，这次联名系列的每一件单品她都参与了样品修改。',
    categorySlug: 'shishang',
    author: '瓜妹',
    authorRole: '时尚生活观察',
    date: '2026-09-07',
    readTime: '4 分钟',
    views: 19870,
    comments: 156,
    featured: false,
    image:
      'https://readdy.ai/api/search-image?query=Fashion%20design%20studio%20editorial%20illustration%20with%20sketch%20boards%20and%20fabric%20swatches%20on%20a%20table%2C%20soft%20beige%20and%20coral%20gradient%20background%2C%20stylized%20flat%20lay%20composition%2C%20warm%20natural%20light%2C%20minimal%20clean%20aesthetic%2C%20no%20text&width=1200&height=800&seq=guagua-art-07&orientation=landscape',
    tags: ['联名', '设计', '跨界'],
    content: [
      '温言的首个设计联名系列日前正式上线。与常见的"挂名"合作不同，系列中每一件单品的版型，她都参与了样品修改。',
      '"最开始连打版是什么都不懂，"温言在采访中笑着说，"所以我就报了课，从最基础的开始学，前后大概花了两年。"',
      '这次的联名系列以基础款为主，颜色克制，强调面料的舒适度。"我不想做那种只能拍照穿一次的衣服，我希望它是能天天穿的。"',
    ],
  },
  {
    id: 'cheng-xingye-late-night-post',
    title: '程星野深夜发文 疑回应分手传闻',
    excerpt:
      '一句"有些路要自己走完"让程星野的深夜动态被解读为回应分手传闻，但目前双方均未正式说明。',
    categorySlug: 'redian',
    author: '吃瓜观察员',
    authorRole: '网络热议追踪',
    date: '2026-09-07',
    readTime: '3 分钟',
    views: 61520,
    comments: 894,
    featured: false,
    image:
      'https://readdy.ai/api/search-image?query=Calm%20night%20editorial%20illustration%20of%20a%20quiet%20city%20window%20at%20midnight%20with%20warm%20lamp%20glow%2C%20muted%20cream%20and%20soft%20coral%20tones%2C%20stylized%20geometric%20shapes%2C%20gentle%20gradient%20sky%2C%20minimal%20clean%20composition%2C%20no%20text&width=1200&height=800&seq=guagua-art-08&orientation=landscape',
    tags: ['深夜动态', '传闻', '理性吃瓜'],
    content: [
      '程星野在凌晨发布了一条只有一句话的动态："有些路，要自己走完。"配图是一张空荡的街道。由于近期有关他感情状况的讨论不断，这条动态很快被解读为回应分手传闻。',
      '不过截至目前，程星野本人及双方团队都没有对传闻作出正式说明。有粉丝在评论区提醒："别过度解读，他本来就很喜欢发这种情绪化的文字。"',
      '娱乐话题的讨论本无可厚非，但在当事人未回应之前，把猜测当成事实，往往会给无关的人带来困扰。这也是我们想提醒的一点：看热闹可以，别替别人下结论。',
    ],
  },
  {
    id: 'su-nianan-studio-statement',
    title: '苏念安工作室发声明 否认不实爆料',
    excerpt:
      '针对网上流传的一段聊天记录截图，苏念安工作室发布声明表示内容失实，并保留追究法律责任的权利。',
    categorySlug: 'yule',
    author: '瓜妹',
    authorRole: '娱乐圈追踪',
    date: '2026-09-06',
    readTime: '3 分钟',
    views: 33420,
    comments: 287,
    featured: false,
    image:
      'https://readdy.ai/api/search-image?query=Editorial%20conceptual%20illustration%20about%20documents%20and%20official%20statement%20seals%2C%20warm%20ivory%20and%20terracotta%20gradient%20background%2C%20stylized%20clean%20geometric%20shapes%2C%20soft%20studio%20lighting%2C%20minimal%20composition%2C%20no%20text&width=1200&height=800&seq=guagua-art-09&orientation=landscape',
    tags: ['声明', '澄清', '不实信息'],
    content: [
      '针对近日在网上流传的一段聊天记录截图，苏念安工作室发布声明，表示相关截图内容失实，工作室已委托律师进行证据保全。',
      '声明中提到，工作室此前已多次与发布方沟通，但相关信息仍在被反复转发。"我们理解大家对艺人的关注，但对编造和传播不实信息的行为，我们会依法处理。"',
      '我们也想借这件事提醒：截图类爆料极易伪造，在官方回应之前，不妨先让信息飞一会儿。',
    ],
  },
  {
    id: 'luyu-jiang-wanqing-second-collab',
    title: '陆屿江晚晴二搭？片方回应：正在接触中',
    excerpt:
      '两人此前的合作收获不少好评，近期有消息称双方将再度合作一部都市题材作品，片方回应"确有接触"。',
    categorySlug: 'yule',
    author: '吃瓜观察员',
    authorRole: '娱乐圈追踪',
    date: '2026-09-06',
    readTime: '3 分钟',
    views: 26890,
    comments: 361,
    featured: false,
    image:
      'https://readdy.ai/api/search-image?query=Urban%20editorial%20illustration%20of%20a%20modern%20city%20skyline%20at%20golden%20hour%2C%20warm%20amber%20and%20coral%20gradient%20background%2C%20stylized%20flat%20buildings%2C%20soft%20haze%2C%20minimal%20clean%20composition%2C%20no%20text&width=1200&height=800&seq=guagua-art-10&orientation=landscape',
    tags: ['二搭', '都市剧', '选角'],
    content: [
      '陆屿与江晚晴此前合作的一部作品口碑不错，近期有消息称两人将再度合作一部都市题材剧集，话题随即升温。',
      '片方相关负责人在回应媒体时表示："确实有在接触，但目前还处在非常初步的阶段，一切以官宣为准。"这个既不否认也不确认的回应，反而让讨论更热了。',
      '选角本身就是双向选择的过程，演员档期、剧本打磨都需要时间。在正式官宣之前，与其反复猜测，不如期待他们各自的新作品。',
    ],
  },
  {
    id: 'gu-yanzhi-debut-film-release',
    title: '新晋导演顾言之新片定档 首支预告引发讨论',
    excerpt:
      '影片首支预告片发布后，一个长镜头的处理方式被业内反复讨论，有人称赞，也有人认为过于冒险。',
    categorySlug: 'yingshi',
    author: '瓜妹',
    authorRole: '影视综艺观察',
    date: '2026-09-05',
    readTime: '4 分钟',
    views: 22150,
    comments: 174,
    featured: false,
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20editorial%20illustration%20with%20a%20projector%20beam%20and%20warm%20dust%20particles%2C%20deep%20amber%20and%20coral%20gradient%20background%2C%20stylized%20geometric%20shapes%2C%20soft%20dramatic%20lighting%2C%20minimal%20clean%20composition%2C%20no%20text&width=1200&height=800&seq=guagua-art-11&orientation=landscape',
    tags: ['定档', '预告片', '新导演'],
    content: [
      '由新晋导演顾言之执导的首部长片正式宣布定档，同步放出的首支预告片在业内引发了不少讨论。',
      '讨论的焦点集中在一个近三分钟的长镜头上。有影评人认为，这个镜头调度完成度很高，"能看出导演对空间和节奏有清晰的想法"；也有观点认为，一部长片开头就用这么大的技术挑战，风险不小。',
      '顾言之在采访中回应说，这个镜头拍了十七次，"我们不是为了炫技，是因为这个故事只能用这种方式讲"。影片最终成色如何，还要等上映后由观众来评判。',
    ],
  },
  {
    id: 'lin-xiaoman-vlog-famous-shop',
    title: '林小满分享日常 vlog 意外带火一家小店',
    excerpt:
      '一条随手拍的日常视频里，林小满去的那家面馆被网友找到，老板说这几天排队的人多了好几倍。',
    categorySlug: 'shishang',
    author: '吃瓜观察员',
    authorRole: '生活方式观察',
    date: '2026-09-05',
    readTime: '3 分钟',
    views: 24760,
    comments: 213,
    featured: false,
    image:
      'https://readdy.ai/api/search-image?query=Cozy%20small%20noodle%20shop%20editorial%20illustration%20with%20steaming%20bowls%20and%20wooden%20counter%2C%20warm%20cream%20and%20coral%20gradient%20background%2C%20stylized%20flat%20shapes%2C%20soft%20evening%20light%2C%20minimal%20clean%20composition%2C%20no%20text&width=1200&height=800&seq=guagua-art-12&orientation=landscape',
    tags: ['vlog', '小店', '烟火气'],
    content: [
      '林小满更新了一条日常 vlog，内容很简单：下班后去家附近吃了一碗面。视频里没有滤镜，也没有刻意摆拍。',
      '没想到的是，有眼尖的网友根据视频里的招牌和街景找到了这家开在巷子里的面馆。老板在接受采访时有点懵："我们开了十几年，最近突然好多人来。"',
      '林小满随后发文提醒大家理性打卡："就是一碗很普通的面，别特意跑太远，点单的时候也请体谅一下店里的阿姨。"一句提醒，反而让更多人觉得这份分享是真的。',
    ],
  },
  {
    id: 'shen-zhibai-new-gadgets',
    title: '沈知白晒新装备 一串配件引发购买热潮',
    excerpt:
      '一条录音室日常里，沈知白桌上的一款小众配件被网友认出，相关型号当天的搜索量明显上涨。',
    categorySlug: 'shuma',
    author: '瓜妹',
    authorRole: '数码潮流观察',
    date: '2026-09-04',
    readTime: '3 分钟',
    views: 18640,
    comments: 142,
    featured: false,
    image:
      'https://readdy.ai/api/search-image?query=Minimal%20desk%20setup%20editorial%20illustration%20with%20headphones%20and%20audio%20device%2C%20warm%20cream%20and%20amber%20gradient%20background%2C%20stylized%20flat%20geometric%20shapes%2C%20soft%20studio%20lighting%2C%20clean%20aesthetic%2C%20no%20text&width=1200&height=800&seq=guagua-art-13&orientation=landscape',
    tags: ['数码', '装备', '录音室'],
    content: [
      '沈知白在社交平台分享了一段录音室日常，视频本身没讲什么，但他桌上的一款音频配件被网友认了出来。',
      '这个型号本身偏小众，价格也不算便宜。不过视频发布当天，相关型号的搜索量明显上涨，几家店铺的库存也被清了一轮。',
      '"他用的东西都挺实在的，不是那种只看颜值的。"一位网友的评论道出了不少人的想法。当然，跟风购买之前，还是建议先确认自己是否真的需要。',
    ],
  },
  {
    id: 'why-people-love-watching-gossip',
    title: '为什么大家越来越爱"云吃瓜"？从心理角度聊聊',
    excerpt:
      '围观别人的热闹，为什么能带来放松感？心理学家其实早有解释，而这背后也藏着一些需要留意的边界。',
    categorySlug: 'qinggan',
    author: '瓜哥',
    authorRole: '主理人',
    date: '2026-09-04',
    readTime: '5 分钟',
    views: 20310,
    comments: 188,
    featured: false,
    image:
      'https://readdy.ai/api/search-image?query=Warm%20illustration%20about%20human%20connection%20and%20curiosity%2C%20soft%20coral%20and%20jade%20green%20gradient%20background%2C%20stylized%20abstract%20shapes%20and%20gentle%20lines%2C%20calm%20editorial%20aesthetic%2C%20minimal%20composition%2C%20no%20text&width=1200&height=800&seq=guagua-art-14&orientation=landscape',
    tags: ['心理', '围观', '边界感'],
    content: [
      '你有没有过这样的时刻：明明很累，却还是忍不住刷完了整条热搜。围观别人的热闹，为什么能让人放松？',
      '心理学上有个常见的解释：当我们把注意力投向他人的故事时，会暂时从自己的生活压力里抽离出来。这种"替代性体验"成本很低，所以特别容易上瘾。',
      '但凡事有边界。当围观变成对具体个人的评头论足，当猜测被当成事实传播，原本的放松就会变成另一种消耗，甚至伤害到毫不相干的人。',
      '所以"吃瓜"这件事，我们的态度一直很简单：看得开心就好，别替别人下结论，也别把自己的情绪搭进去。热闹是别人的，生活才是自己的。',
    ],
  },
];

export const quickNews = [
  { time: '14:32', tag: '快讯', text: '《周末慢半拍》第二期阵容曝光，飞行嘉宾名单引发讨论' },
  { time: '13:58', tag: '新瓜', text: '陆屿先行曲登上多个音乐平台新歌榜首位' },
  { time: '12:41', tag: '更新', text: '江晚晴红毯礼服设计师发布制作过程手记' },
  { time: '11:20', tag: '热议', text: '顾南川直播回应片段二次发酵，正片播出时间成焦点' },
  { time: '10:05', tag: '快讯', text: '程星野新代言官宣，物料释出仅两小时转发破十万' },
  { time: '09:47', tag: '新瓜', text: '林小满新剧路透更新，雨中对手戏片段新增三张' },
  { time: '09:12', tag: '更新', text: '沈知白巡演加场公告发布，官方提醒谨防加价转售' },
  { time: '08:30', tag: '热议', text: '温言联名系列首批单品售罄，补货时间待定' },
];

export const hotRankIds = [
  'cheng-xingye-late-night-post',
  'gu-nanchuan-replies-rumors',
  'su-nianan-variety-ratings-top',
  'luyu-new-album-teaser',
  'su-nianan-studio-statement',
  'lin-xiaoman-new-drama-leak',
  'luyu-jiang-wanqing-second-collab',
  'jiang-wanqing-red-carpet-look',
];

export const faqs = [
  {
    q: '瓜哥吃瓜多久更新一次？',
    a: '首页的"快讯时间线"全天滚动更新，新瓜速递栏目会随热点实时补充。一般来说，工作日的上午和深夜是更新相对密集的时段。',
  },
  {
    q: '这些内容是从哪里来的？',
    a: '我们把公开渠道中正在被讨论的话题整理成更容易阅读的条目，并注明时间与来源栏目。对于尚未有官方确认的传闻，我们会在正文里明确标注"尚未证实"。',
  },
  {
    q: '为什么有的传闻你们不跟进？',
    a: '涉及个人隐私、未经证实的私生活猜测，以及可能对无关人员造成伤害的内容，我们会主动放弃。看热闹有分寸，这条底线我们不轻易让步。',
  },
  {
    q: '可以投稿或者推荐话题吗？',
    a: '可以。通过页脚的联系邮箱把线索发给我们，附上可核实的公开来源会更有帮助。核实通过后，我们会在栏目里注明线索来源。',
  },
  {
    q: '手机上也能正常看吗？',
    a: '可以。整站做了响应式适配，电脑、平板和手机上都能正常阅读，导航也会自动收起成菜单。',
  },
  {
    q: '文章内容会定期整理吗？',
    a: '会。对于持续发酵的话题，我们会定期回访并更新进展，避免读者只看到最早的版本而产生误判。',
  },
];

export const testimonials = [
  {
    name: '阿栗',
    tag: '通勤党',
    text: '以前刷热搜要从头翻到尾，现在打开瓜哥，早高峰十分钟就能把今天发生了什么看个大概。',
  },
  {
    name: '小满不圆',
    tag: '内容从业者',
    text: '最欣赏的是他们不急着下结论。传闻会明确写"尚未证实"，这点在同类站点里很难得。',
  },
  {
    name: '老周',
    tag: '深度吃瓜选手',
    text: '快讯时间线做得挺好，时间点和栏目标得清清楚楚，回看某个话题的来龙去脉很方便。',
  },
];

export const stats = [
  { label: '每日更新快讯', value: '120+' },
  { label: '累计收录话题', value: '3.6 万' },
  { label: '覆盖栏目', value: '6 个' },
  { label: '读者平均停留', value: '4.2 分钟' },
];

export const principles = [
  {
    icon: 'ri-time-line',
    title: '快，但不抢跑',
    desc: '热点来了先第一时间整理，但没核实的信息不会当成事实发布。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '有分寸地围观',
    desc: '不跟进未经证实的私生活猜测，不消费与话题无关的普通人。',
  },
  {
    icon: 'ri-file-list-3-line',
    title: '标注来源与时间',
    desc: '每条内容都带上时间与栏目，方便你判断信息的新鲜程度。',
  },
  {
    icon: 'ri-refresh-line',
    title: '持续回访更新',
    desc: '发酵中的话题会定期回看，把最新进展补充进原有内容。',
  },
];